module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraBoldItalic.4a455b98.ttf";